// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-q_ge","advertDetailService__price":"c-q_gf"};